import { NgModule } from '@angular/core'
import {
  CategoryPageMetaResolver,
  CmsConfig,
  PRODUCT_NORMALIZER,
  PRODUCT_SEARCH_PAGE_NORMALIZER,
  ProductAdapter,
  ProductLoadingService,
  ProductPageMetaResolver,
  provideConfig,
  SearchPageMetaResolver,
  UrlModule
} from '@spartacus/core'
import { MiltenyiProductPageMetaResolver } from './services/miltenyi-product-page-meta.resolver'
import { MiltenyiCategoryPageMetaResolver } from './services/miltenyi-category-page-meta.resolver'
import { MiltenyiSearchPageMetaResolver } from './services/miltenyi-search-page-meta.resolver'
import {
  PdpInfoBoxDetailsAntibodyComponent
} from './components/pdp-infobox-details-antibody/pdp-infobox-details-antibody.component'
import { CommonModule } from '@angular/common'
import { PdpHeaderInfoComponent } from './components/pdp-header-info/pdp-header-info.component'
import {
  PdpInfoBoxDetailsNonAntibodyComponent
} from './components/pdp-infobox-details-nonantibody/pdp-infobox-details-nonantibody.component'
import {
  CarouselModule,
  IconModule,
  MediaModule,
  OutletModule,
  OutletRefModule,
  PageComponentModule,
  StarRatingModule
} from '@spartacus/storefront'
import { ProductNormalizer } from './convertors/product-normalizer'
import { ClipboardModule } from '@angular/cdk/clipboard'
import { MbAddToCartModule } from '../cart/components/mb-add-to-cart/mb-add-to-cart.module'
import { PdpGalleryComponent } from './components/pdp-gallery/pdp-gallery.component'
import { PdpVariantsListComponent } from './components/pdp-variants-list/pdp-variants-list.component'
import {
  VARIANT_OPTION_TO_PRODUCT_LINE_NORMALIZER,
  VariantOptionToProductLineModelNormalizer
} from './components/product-line/product-line.component.normalizer'
import {
  ViewComponentsDialogModule
} from './components/product-line/view-components-dialog/view-components-dialog.module'
import { MbProductDataImagesTabAdapter } from './connectors/product-data-images'
import { MbOccProductDataImagesTabAdapter } from './adapters/mb-occ-product-data-images-tab.adapter'
import {
  PdpProductDataImageTabComponent
} from './components/pdp-tabs/pdp-product-data-image-tab/pdp-product-data-image-tab.component'
import { ProductLineComponent } from './components/product-line/product-line.component'
import {
  PdpProductFiltersComponent
} from './components/pdp-product-filters/pdp-product-filters.component'
import {
  PdpProductFilterComponent
} from './components/pdp-product-filters/pdp-product-filter/pdp-product-filter.component'
import { MbI18nModule } from '../translations/mb-i18n.module'
import { PdpTabsComponent } from './components/pdp-tabs/pdp-tabs.component'
import {
  PdpReferencesTabComponent
} from './components/pdp-tabs/pdp-references-tab/pdp-references-tab.component'
import {
  PdpReviewsTabComponent
} from './components/pdp-tabs/pdp-reviews-tab/pdp-reviews-tab.component'
import {
  MbFeaturedProductAdapter,
  MbProductAdapter,
  MbProductByOriginalCodeAdapter,
  MbProductReviewsAdapter,
  MbProductTabApplicationsAdapter,
  MbProductTabReferencesAdapter,
  MbProductTabSpecificationsAdapter
} from './connectors'
import {
  MbOccFeaturedProductsAdapter,
  MbOccProductAdapter,
  MbOccProductReviewsAdapter,
  MbOccProductTabApplicationsAdapter,
  MbOccProductTabReferencesAdapter,
  MbOccProductTabResourcesAdapter
} from './adapters'
import { DirectiveModule } from '../shared/directive.module'
import { ClipboardPopupModule } from '../shared/components/clipboard-popup/clipboard-popup.module'
import { RouterModule } from '@angular/router'
import {
  ViewMultiValueDialogModule
} from './components/product-line/view-multi-value-dialog/view-multi-value-dialog.module'
import {
  PdpApplicationsTabComponent
} from './components/pdp-tabs/pdp-applications-tab/pdp-applications-tab.component'
import {
  PdpGalleryDialogModule
} from '../shared/components/pdp-gallery-dialog/pdp-gallery-dialog.module'
import { QuantityCounterModule } from '../shared/components/quantity-counter/quantity-counter.module'
import {
  PdpGalleryCarouselModule
} from '../shared/components/pdp-gallery-carousel/pdp-gallery-carousel.module'
import {
  PdpPublicationsDialogModule
} from './components/pdp-tabs/pdp-applications-tab/pdp-publications-dialog/pdp-publications-dialog.module'
import {
  PdpApplicationItemComponent
} from './components/pdp-tabs/pdp-applications-tab/pdp-application-item/pdp-application-item.component'
import {
  PdpSpecificationsTabComponent
} from './components/pdp-tabs/pdp-specifications-tab/pdp-specifications-tab.component'
import {
  MbOccProductSpecificationsAdapter
} from './adapters/ mb-occ-product-tab-specifications.adapter'
import { SafeHtmlModule } from '../cms/pipes/sanitize-html/safe-html.module'
import {
  PdpExtendedValidationTabComponent
} from './components/pdp-tabs/pdp-extended-validation-tab/pdp-extended-validation-tab.component'
import { MbProductTabExtendedValidationAdapter } from './connectors/extended-validation'
import {
  MbOccProductTabExtendedValidationAdapter
} from './adapters/mb-occ-product-tab-extended-validation.adapter'
import { VideoModalModule } from '../cms/components/shared/video-modal/video-modal.module'
import {
  PdpResourcesTabComponent
} from './components/pdp-tabs/pdp-resources-tab/pdp-resources-tab.component'
import { MbProductTabResourcesAdapter } from './connectors/resources'
import { mbProductRoutingConfig } from './config/product-routing-config'
import { EffectsModule } from '@ngrx/effects'
import { effects } from './store/effects'
import { MbProductLoadingService } from './services/mb-product-loading.service'
import {
  ProductLineWishlistModule
} from '../shared/components/product-line-wishlist/product-line-wishlist.module'
import { MbOccProductByOriginalCodeAdapter } from './adapters/mb-occ-product-by-original-code.adapter'
import { CmsDirectivesModule } from '../cms/directives/cms-directives.module'
import { OccProductSearchPageNormalizer } from './convertors/occ-product-search-page-normalizer'
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap'
import { RelatedProductsModule } from '../shared/components/related-products/related-products.module'

@NgModule({
  providers: [
    provideConfig({
      cmsComponents: {
        PdpHeaderAntibodyComponent: {
          component: PdpHeaderInfoComponent
        },
        PdpInfoBoxAntibodyComponent: {
          component: PdpInfoBoxDetailsAntibodyComponent
        },
        PdpHeaderInfoboxComponent: {
          component: PdpHeaderInfoComponent
        },
        PdpHeaderInfoboxSummaryComponent: {
          component: PdpInfoBoxDetailsNonAntibodyComponent
        },
        PdpGalleryComponent: {
          component: PdpGalleryComponent
        },
        PdpProductVariantsComponent: {
          component: PdpVariantsListComponent
        },
        ReferencesTabComponent: {
          component: PdpReferencesTabComponent
        },
        CMSTabParagraphContainer: {
          component: PdpTabsComponent
        },
        ReviewsTabComponent: {
          component: PdpReviewsTabComponent
        },
        ExtendedValidationTabComponent: {
          component: PdpExtendedValidationTabComponent
        },
        ApplicationsTabComponent: {
          component: PdpApplicationsTabComponent
        },
        SpecificationTabComponent: {
          component: PdpSpecificationsTabComponent
        },
        ImagesAndDataTabComponent: {
          component: PdpProductDataImageTabComponent
        },
        ResourcesTabComponent: {
          component: PdpResourcesTabComponent
        }
      }
    } as CmsConfig),
    provideConfig(mbProductRoutingConfig),
    {
      provide: ProductPageMetaResolver,
      useExisting: MiltenyiProductPageMetaResolver
    },
    {
      provide: CategoryPageMetaResolver,
      useExisting: MiltenyiCategoryPageMetaResolver
    },
    {
      provide: SearchPageMetaResolver,
      useExisting: MiltenyiSearchPageMetaResolver
    },
    {
      provide: VARIANT_OPTION_TO_PRODUCT_LINE_NORMALIZER,
      useExisting: VariantOptionToProductLineModelNormalizer,
      multi: true
    },
    {
      provide: PRODUCT_NORMALIZER,
      useExisting: ProductNormalizer,
      multi: true
    },
    {
      provide: PRODUCT_SEARCH_PAGE_NORMALIZER,
      useExisting: OccProductSearchPageNormalizer,
      multi: true,
    },
    {
      provide: MbProductReviewsAdapter,
      useExisting: MbOccProductReviewsAdapter,
    },
    {
      provide: MbProductTabReferencesAdapter,
      useExisting: MbOccProductTabReferencesAdapter,
    },
    {
      provide: MbProductTabApplicationsAdapter,
      useExisting: MbOccProductTabApplicationsAdapter
    },
    {
      provide: MbProductTabSpecificationsAdapter,
      useExisting: MbOccProductSpecificationsAdapter
    },
    {
      provide: MbProductTabExtendedValidationAdapter,
      useExisting: MbOccProductTabExtendedValidationAdapter
    },
    {
      provide: MbProductDataImagesTabAdapter,
      useExisting: MbOccProductDataImagesTabAdapter
    },
    {
      provide: MbProductTabResourcesAdapter,
      useExisting: MbOccProductTabResourcesAdapter
    },
    {
      provide: MbProductAdapter,
      useExisting: MbOccProductAdapter
    },
    {
      provide: ProductAdapter,
      useExisting: MbProductAdapter
    },
    {
      provide: ProductLoadingService,
      useExisting: MbProductLoadingService
    },
    {
      provide: MbProductByOriginalCodeAdapter,
      useExisting: MbOccProductByOriginalCodeAdapter
    },
    {
      provide: MbFeaturedProductAdapter,
      useExisting: MbOccFeaturedProductsAdapter
    }
  ],
  exports: [
    PdpResourcesTabComponent,
    PdpApplicationsTabComponent,
    PdpSpecificationsTabComponent,
    PdpReferencesTabComponent,
    PdpTabsComponent
  ],
  imports: [
    StarRatingModule,
    MbI18nModule,
    CommonModule,
    IconModule,
    OutletRefModule,
    ClipboardModule,
    QuantityCounterModule,
    MbAddToCartModule,
    ViewComponentsDialogModule,
    PageComponentModule,
    OutletModule,
    DirectiveModule,
    ClipboardPopupModule,
    CarouselModule,
    MediaModule,
    UrlModule,
    RouterModule,
    ViewMultiValueDialogModule,
    PdpGalleryDialogModule,
    PdpGalleryCarouselModule,
    PdpPublicationsDialogModule,
    SafeHtmlModule,
    VideoModalModule,
    EffectsModule.forFeature(effects),
    CmsDirectivesModule,
    ProductLineWishlistModule,
    NgbDropdownModule,
    RelatedProductsModule
  ],
  declarations: [
    PdpInfoBoxDetailsAntibodyComponent,
    PdpHeaderInfoComponent,
    PdpVariantsListComponent,
    ProductLineComponent,
    PdpInfoBoxDetailsNonAntibodyComponent,
    PdpGalleryComponent,
    PdpProductFiltersComponent,
    PdpProductFilterComponent,
    PdpTabsComponent,
    PdpReferencesTabComponent,
    PdpExtendedValidationTabComponent,
    PdpReviewsTabComponent,
    PdpApplicationsTabComponent,
    PdpApplicationItemComponent,
    PdpSpecificationsTabComponent,
    PdpProductDataImageTabComponent,
    PdpResourcesTabComponent,
  ],
})
export class ProductModule {
}
